import { INSPECTOR_SUBDIAGRAM } from "../../../constants/inspectorConstants";
import Symbol from "./Symbol";

class Subdiagram extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("Subdiagram", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            text: { isVisible: false, value: null, label: "Texto" },
        };                
    }

    getInspector() {
        return INSPECTOR_SUBDIAGRAM;
    }
}

export default Subdiagram;
